<template>
    <b-card>
        <b-button class="float-right mt-2" variant="secondary"  @click="cancel()"><i class="fa fa-arrow-left mr-2" aria-hidden="true"></i>Back</b-button>
        <b-tabs card v-model="tabIdx" align="center">
            <b-tab title="Summary" active>
                <b-card-body>
                    <b-form @submit.stop.prevent="onSubmit">
                        <!-- disable input fields when the user can only view and not update  -->

                        <b-form-group
                            id="order_category_id-group"
                            label="Category*"
                            label-for="input-order_category_id"
                            label-cols="3"
                        >
                            <b-form-select
                                id="input-order_category_id"
                                v-model="model.order_category_id"
                                required
                                :options="
                                    categories.map(x => ({
                                        value: x.id,
                                        text: x.name,
                                    }))
                                "
                                :disabled="canView"
                            >
                                <template #first>
                                    <b-form-select-option :value="null" disabled
                                        >Select Category</b-form-select-option
                                    >
                                </template>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group
                            id="name-group"
                            label="Name*"
                            label-for="input-name"
                            label-cols="3"
                        >
                            <b-form-input
                                type="text"
                                id="input-name"
                                v-model="model.name"
                                required
                                placeholder="Enter Name"
                                trim
                                :disabled="canView"
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="description-group"
                            label="Description"
                            label-for="input-description"
                            label-cols="3"
                        >
                            <b-form-input
                                type="text"
                                id="input-description"
                                v-model="model.description"
                                placeholder="Enter description"
                                trim
                                :disabled="canView"
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="order_type_id-group"
                            label="Primary Type*"
                            label-for="input-order_type_id"
                            label-cols="3"
                        >
                            <b-form-select
                                id="input-order_type_id"
                                v-model="model.order_type_id"
                                required
                                :options="primaryTypes"
                                :disabled="canView"
                            >
                                <template #first>
                                    <b-form-select-option :value="null" disabled
                                        >---Select Primary
                                        Type---</b-form-select-option
                                    >
                                </template>
                            </b-form-select>
                        </b-form-group>

                        <b-form-group
                            id="secondary_order_type_id-group"
                            label="Secondary Type"
                            label-for="input-secondary_order_type_id"
                            label-cols="3"
                        >
                            <b-form-select
                                id="input-secondary_order_type_id"
                                v-model="model.secondary_order_type_id"
                                :options="secondaryTypes"
                                :disabled="!isSecondaryTypeValid"
                            >
                                <template #first>
                                    <b-form-select-option :value="null"
                                        >No Secondary Type</b-form-select-option
                                    >
                                </template>
                            </b-form-select>
                        </b-form-group>

                        <b-button-group size="sm">
                            <b-button
                                variant="secondary"
                                :disabled="loading ? true : false"
                                @click="cancel()"
                                >{{ cancelLabel }}</b-button
                            >

                            <!-- render the sumbit button only if the user can create and/or update -->
                            <b-button
                                type="submit"
                                variant="primary"
                                :disabled="loading ? true : false"
                                v-if="
                                    hasPermissionUpdate || hasPermissionCreate
                                "
                                >{{ submitLabel }}</b-button
                            >
                            <b-button
                                @click="deleteItem()"
                                class="mr-2"
                                variant="warning"
                                v-if="hasPermissionDelete &&  this.model.id"
                            >
                                Delete
                            </b-button>
                        </b-button-group>
                    </b-form>
                </b-card-body>
            </b-tab>
            <b-tab title="Primary Items" :disabled="!template.order_type_id">
                <b-card-body>
                    <template-items
                        v-if="tabIdx === 1"
                        :is-secondary-order-type="false"
                    />
                </b-card-body>
            </b-tab>
            <b-tab
                title="Secondary Items"
                :disabled="!template.secondary_order_type_id"
            >
                <b-card-body>
                    <template-items
                        v-if="tabIdx === 2"
                        :is-secondary-order-type="true"
                    />
                </b-card-body>
            </b-tab>
        </b-tabs>
    </b-card>
</template>
<script>
import TemplateItems from './TemplateItems'
import permissionsMixins from '@/mixins/permissionsMixins'
import popupMixins from '@/mixins/popupMixins'

const modelKeys = [
    'id',
    'order_category_id',
    'name',
    'description',
    'order_type_id',
    'secondary_order_type_id',
]

export default {
    name: 'OrderTemplates-ViewItem',
    mixins: [permissionsMixins, popupMixins],
    components: {
        TemplateItems,
    },
    data() {
        return {
            componentName: 'Activity Template',
            model: {},
            loading: false,
            hasErrors: false,
            tabIdx: 0,
        }
    },
    computed: {
        /**
         * True if the user has permissions to create and clicked the create button, otherwise false.
         */
        canCreate() {
            
            return !this.model.id &&
                this.user_permissions.includes('create.order.templates')
                ? true
                : false
        },
        /**
         * True if the user has permission to view but not update an order template and clicked the view button on a template in the table, otherwise false.
         */
        canView() {
            return this.model.id &&
                !this.user_permissions.includes('update.order.templates') &&
                this.user_permissions.includes('view.order.templates')
                ? true
                : false
        },
        /**
         * True if the user has permission to update an order template and clicked the view button on a template in the table, otherwise false.
         */
        canUpdate() {
            return this.model.id &&
                this.user_permissions.includes('update.order.templates')
                ? true
                : false
        },
        submitLabel() {
            if (this.loading && this.model.id) {    
                return 'Updating...'
            } else if (this.loading) {
                return 'Creating...'
            } else if (this.model.id) {
                return 'Update'
            } else {
                return 'Create'
            }
        },
        cancelLabel() {
            if (this.canView) {
                return 'Back'
            } else {
                return 'Cancel'
            }
        },

        template() {
            return this.$store.state.orderTemplate.selectedTemplate
        },
        categories() {
            return this.$store.state.orderCategory.categories
        },
        types() {
            return this.$store.state.orderType.items
        },
        selected_trans_type() {
            const {
                model: { order_type_id },
                types,
            } = this
            return (
                (types.find(x => x.id == order_type_id) || {})
                    .transaction_type || {}
            )
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        entities() {
            return this.$store.getters['transactionType/entities']
        },

        flows() {
            return this.$store.getters['transactionType/flows']
        },
        primaryTypes() {
            const { types } = this
            return types.map(x => ({
                value: x.id,
                text: x.name,
            }))
        },
        secondaryTypes() {
            const { types, entities, flows } = this
            return types
                .filter(
                    x =>
                        (x.transaction_type && x.transaction_type.entity) ==
                            entities.Customer &&
                        (x.transaction_type && x.transaction_type.flow) ==
                            flows.Inbound
                )
                .map(x => ({
                    value: x.id,
                    text: x.name,
                }))
        },
        isSecondaryTypeValid() {
            const { selected_trans_type, entities, flows } = this
            return !!(
                selected_trans_type &&
                entities.Customer == selected_trans_type.entity &&
                flows.Outbound == selected_trans_type.flow
            )
        },
    },
    watch: {
        
        template: {
            handler: function (_val) {
                console.log('template-watch', _val)
                for (const key of modelKeys) {
                    this.$set(this.model, key, _val[key] || null)
                }
            },
            deep: true,
        },
        selected_trans_type: {
            handler: function (_val, prev) {
                if (prev.id) this.model.secondary_order_type_id = null
            },
            deep: true,
        },
    },
    mounted() {
        console.log("modell",this.model)
        // ensure that the selected template and model are cleared for a new template or updated with an existing template
        for (const key of modelKeys) {
            this.$set(this.model, key, this.template[key] || null)
        }
        console.log('template-mounted', this.model)
        console.log('entities', this.entities)
        console.log('flows', this.flows)
        console.log('types', this.types)
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        async onSubmit() {
            try {
                this.loading = true
                const model = { ...this.model }
                console.log('model', model)
                const action = model.id ? 'update' : 'create'
                const path = `orderTemplate/${action}`
                const valid = await this.$validator.validate()
                if (!valid) throw new Error('Invalid')
                await this.$store.dispatch(path, model)
                this.$emit('success', action, model.name)
            } catch (error) {
                console.log('error', error.message)
                //let message = error.message
                if (error.message.indexOf('Duplicate entry')) {
                    //message = 'Duplicate Entry'
                    this.genericToast(
                        this.componentName,
                        'Duplicate',
                        'danger',
                        `"${this.model.name}" is already in use. Please choose a different name`
                    )
                }
            } finally {
                this.loading = false
            }
        },
        deleteItem() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'orderTemplate/delete'

            // Generate and display confirmation prompt
            const title = 'Delete Activity Template?'
            const message = `Are you sure you want to delete ${model.name}?`
            const errorMsg = 'Unable to delete Activity Template!'

            this.$emit(
                'delete-item',
                message,
                title,
                model.id,
                () => {
                    this.$emit('success', 'Delete', model.name)
                },
                path,
                errorMsg
            )
        },
    },
}
</script>
<style></style>
